import React from 'react';
import { Stack, Tabs, Text, Title } from '@mantine/core';
import { useNavigate } from 'react-router-dom';

export function ProjectsNavigation({
  view,
}: {
  view: 'projects' | 'pre-site';
}) {
  const navigate = useNavigate();
  return (
    <Stack gap="sm">
      <div>
        <Title order={2}>Projects</Title>
        <Text c="dimmed">
          Find ordering reviews and pre-site form reviews.
        </Text>
      </div>
      <Tabs
        value={view}
        onChange={(value) =>
          navigate(value === 'pre-site' ? '/projects/pre-site' : '/projects')
        }
      >
        <Tabs.List>
          <Tabs.Tab value="projects">Ordering projects</Tabs.Tab>
          <Tabs.Tab value="pre-site">Pre-site form reviews</Tabs.Tab>
        </Tabs.List>
      </Tabs>
    </Stack>
  );
}
